import { Navigate, Route } from 'react-router-dom';
import { Layout } from '../admin/components/Layout';
import { AdminPage } from '../admin/pages/AdminPage';
import { AddJournalPage } from '../admin/pages/AddJournalPage';
import { EditJournalPage } from '../admin/pages/EditJournalPage';
import { LoginPage } from '../admin/pages/LoginPage';
import { NotFoundPage } from '../pages/NotFoundPage';

export function useRoutes(isLogin) {
    if (isLogin) {
        return (
            <Route path='/admin' element={<Layout />}>
                <Route index element={<AdminPage />} />
                <Route path='add/journal' element={<AddJournalPage />} />
                <Route path='edit/journal/:id' element={<EditJournalPage />} />
                <Route path='*' element={<Navigate to='/admin' />} />
            </Route>
        )
    }

    return (
        <>
            <Route path='/login' element={<LoginPage />} />
            <Route path='*' element={<NotFoundPage />} />
        </>
    )
}
